import React from 'react';

function RestrictedDevice() {
  return (
    <div>
      <h1>Restricted Device</h1>
      <p>Our apologies, howevwer we do not yet support mobile devices at this time.</p>
    </div>
  );
}

export default RestrictedDevice;
